import setupAdobe from "../analytics/setupAdobe";

const setupAnalytics = store => setupAdobe(store);

export default setupAnalytics;
